import React, { Component } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";

const formats = [
  //"font",
  "size",
  "bold",
  "italic",
  "underline",
  "list",
  "bullet",
  "color",
  "background",
  "link",
  "image",
];

const modules = {
  toolbar: [
    //[{ font: [] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ color: [] }, { background: [] }],
    ["link"],
    ["image"],
  ],
};

const Editor = ({ name, value, onChange }) => {
  return (
    <div className="wrap">
      <ReactQuill
        name={name}
        value={value}
        onChange={onChange}
        theme="snow"
        modules={modules}
        formats={formats}
        bounds={".wrap"}
      />
    </div>
  );
};

export default Editor;
